import React, { useState, useEffect } from 'react';
import UFOImage from '../images/UFO.webp';

const LoadingScreen = ({ onLoadingComplete }) => {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setProgress(prev => {
        if (prev >= 100) {
          clearInterval(interval);
          setTimeout(() => onLoadingComplete(), 500);
          return 100;
        }
        return prev + 2;
      });
    }, 50);

    return () => clearInterval(interval);
  }, [onLoadingComplete]);

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100vw',
      height: '100vh',
      background: '#0a0a0a',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 9999,
      animation: 'fadeOut 0.5s ease-out 2.5s forwards'
    }}>
      <style>{`
        @keyframes float {
          0%,100% { transform: translateY(0px); }
          25% { transform: translateY(-15px); }
          50% { transform: translateY(-25px); }
          75% { transform: translateY(-15px); }
        }
        @keyframes beam {
          0%,100% { opacity: 0.2; height: 0; }
          50% { opacity: 0.5; height: 180px; }
        }
        @keyframes glow {
          0%,100% { filter: drop-shadow(0 0 20px #ff8c00) drop-shadow(0 0 30px #ffa500); }
          50% { filter: drop-shadow(0 0 40px #ff8c00) drop-shadow(0 0 60px #ffa500); }
        }
        @keyframes fadeOut { to { opacity: 0; visibility: hidden; } }
        @keyframes shimmer { 0% { background-position: -200% 0; } 100% { background-position: 200% 0; } }
      `}</style>

      <div style={{
        position: 'relative',
        animation: 'float 3s ease-in-out infinite',
        marginBottom: '80px'
      }}>
        <img 
          src={UFOImage} 
          alt="UFO"
          style={{
            width: '200px',
            height: 'auto',
            animation: 'glow 2s ease-in-out infinite'
          }}
        />
      </div>

      <div style={{
        width: '400px',
        maxWidth: '80vw',
        height: '20px',
        background: '#111',
        borderRadius: '10px',
        overflow: 'hidden',
        boxShadow: '0 0 25px rgba(255, 140, 0, 0.3)',
        position: 'relative'
      }}>
        <div style={{
          width: `${progress}%`,
          height: '100%',
          background: 'linear-gradient(90deg, #ff0080 0%, #ff8c00 16%, #ffd700 33%, #00ff00 50%, #00bfff 66%, #8a2be2 83%, #ff0080 100%)',
          backgroundSize: '300% 100%',
          animation: 'shimmer 3s ease-in-out infinite',
          borderRadius: progress < 99 ? '10px 0 0 10px' : '10px',
          boxShadow: '0 0 25px rgba(255, 140, 0, 0.6)',
          transition: 'width 0.3s ease-out, border-radius 0.3s ease-out'
        }} />
      </div>
    </div>
  );
};

export default LoadingScreen;